import React from 'react'
import { useCookies } from 'react-cookie';

export default function useGetCsrfToken() {
    const [cookies, setCookies] = useCookies(['_csrf_token']);
    //find csrf token to url params
    const params = new URLSearchParams(window.location.search);
    const csrfTokenByUrl = params.get("_csrf");
  
    return cookies._csrf_token || localStorage.getItem("_csrf_token") || csrfTokenByUrl || null
}